//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LegacyButton',
  props: {
    disabled: {
      type: Boolean,
    },
    color: {
      type: String,
      default: 'primary',
    },
    outline: {
      type: Boolean,
    },
    plain: {
      type: Boolean,
    },
    noFocus: {
      type: Boolean,
    },
    small: {
      type: Boolean,
    },
    hover: {
      type: Boolean,
    },
    normal: {
      type: Boolean,
    },
  },
};
